/* ============================================================
   OBEE EXTRACTS — Generation 2 Bühne
   Age Gate → zwei Klicks → Sorte. Farbnebel per WebGL.
   Shader übernommen aus obee-lab-v2.

   Bewegungsvorgaben (abgestimmt am Testaufbau):
     Frucht   Variante B "Einflug"  ·  Tempo 400 ms
     Name     Variante 2 "Schieben" ·  Richtung folgt der Drehung
     Drehung  1050 ms

   Seit 13.08.2026: nur noch eine Frucht, oben rechts hinter der
   Sortenüberschrift. Die Bühne bleibt der ruhige Rahmen.
   ============================================================ */
(function () {
  'use strict';

  var D = window.OBEE_STRAINS; if (!D) return;
  var S = D.strains;
  var FRAMES  = 48;
  var SPIN_MS = 1050;   // Dauer einer vollen Umdrehung
  var FRUIT_MS = 400;   // Tempo des Einflugs
  var STAGGER  = 0;     // Versatz (nur noch eine Frucht, bleibt der Vollständigkeit halber)
  var TAPS_NEEDED = 2;  // Klicks auf die Touch-Taste bis zur Zündung
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var scene = document.getElementById('scene'); if (!scene) return;
  var dev    = scene.querySelector('.scene-device');
  var imgs   = dev.querySelectorAll('img');
  var dots   = scene.querySelectorAll('.scene-tap .dots i');
  var tapP   = scene.querySelector('.scene-tap p');
  var wordEl = scene.querySelector('.scene-word');
  var fruitB = scene.querySelector('.scene-fruits');
  var metaEl = scene.querySelector('.scene-meta');
  var nameEl = scene.querySelector('[data-name]');
  var typeEl = scene.querySelector('[data-type]');
  var aromaEl= scene.querySelector('[data-aroma]');
  var terpEl = scene.querySelector('[data-terps]');
  var genEl  = scene.querySelector('[data-gen]');
  var idxEl  = scene.querySelector('[data-idx]');
  var hudEl  = scene.querySelector('[data-hud]');
  var packEl = scene.querySelector('.scene-pack');
  var rail   = scene.querySelector('.scene-rail');
  var btns   = rail ? rail.querySelectorAll('button') : [];

  var cur = 0, lit = false, taps = 0, busy = false, auto = null, dir = 1;

  /* ---------- Farbe ---------- */
  function hex2rgb(h) {
    h = h.replace('#', '');
    return [parseInt(h.slice(0,2),16)/255, parseInt(h.slice(2,4),16)/255, parseInt(h.slice(4,6),16)/255];
  }
  function mul(c, f) { return [c[0]*f, c[1]*f, c[2]*f]; }

  /* ============================================================
     WEBGL FARBNEBEL
     ============================================================ */
  var glc = document.getElementById('fog');
  var gl = glc && (glc.getContext('webgl', { antialias:false, alpha:false }) ||
                   glc.getContext('experimental-webgl'));
  var uni = {}, glOK = !!gl, ig = 0, igTarget = 0;
  var C1 = hex2rgb(S[0].accent), C2 = mul(C1, .28);
  var C1t = C1.slice(), C2t = C2.slice();

  var VS = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  var FS = [
    'precision highp float;',
    'uniform vec2 uRes; uniform float uTime, uIg; uniform vec3 uC1, uC2;',
    'float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
    ' return mix(mix(hash(i),hash(i+vec2(1,0)),f.x),mix(hash(i+vec2(0,1)),hash(i+vec2(1,1)),f.x),f.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*noise(p);p*=2.03;a*=.5;}return v;}',
    'void main(){',
    ' vec2 p=(gl_FragCoord.xy-.5*uRes)/uRes.y;',
    ' float t=uTime*.042;',
    ' vec2 q=vec2(fbm(p*1.5+t),fbm(p*1.5+vec2(3.7,1.3)-t*.8));',
    ' float f=fbm(p*2.1+q*1.5+t*.6);',
    ' float d=length(p);',
    ' vec3 base=vec3(.028,.028,.034);',
    ' vec3 col=mix(uC2,uC1,clamp(f*1.15-.06,0.,1.));',
    ' col=mix(base,col,smoothstep(1.5,.02,d)*uIg);',
    ' col+=uC1*pow(smoothstep(.66,.0,d),3.5)*.55*uIg;',
    ' col*=1.-.44*smoothstep(.35,1.4,length(p));',
    ' col+=(hash(gl_FragCoord.xy+fract(uTime))-.5)*.022;',
    ' gl_FragColor=vec4(col,1.);',
    '}'
  ].join('\n');

  function mkShader(t, src) {
    var o = gl.createShader(t); gl.shaderSource(o, src); gl.compileShader(o);
    if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) { console.warn(gl.getShaderInfoLog(o)); return null; }
    return o;
  }
  if (glOK) {
    var vs = mkShader(gl.VERTEX_SHADER, VS), fs = mkShader(gl.FRAGMENT_SHADER, FS);
    if (vs && fs) {
      var pr = gl.createProgram(); gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
      if (gl.getProgramParameter(pr, gl.LINK_STATUS)) {
        gl.useProgram(pr);
        var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
        var l = gl.getAttribLocation(pr, 'p');
        gl.enableVertexAttribArray(l); gl.vertexAttribPointer(l, 2, gl.FLOAT, false, 0, 0);
        ['uRes','uTime','uIg','uC1','uC2'].forEach(function (n) { uni[n] = gl.getUniformLocation(pr, n); });
      } else glOK = false;
    } else glOK = false;
  }
  if (!glOK && glc) glc.style.display = 'none';

  function sizeFog() {
    if (!glOK) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.6);
    glc.width  = Math.floor(scene.clientWidth  * dpr);
    glc.height = Math.floor(scene.clientHeight * dpr);
    gl.viewport(0, 0, glc.width, glc.height);
  }
  window.addEventListener('resize', sizeFog); sizeFog();

  var t0 = performance.now();
  function renderFog(now) {
    if (glOK) {
      ig += (igTarget - ig) * 0.035;
      for (var i = 0; i < 3; i++) {
        C1[i] += (C1t[i] - C1[i]) * 0.04;
        C2[i] += (C2t[i] - C2[i]) * 0.04;
      }
      gl.uniform2f(uni.uRes, glc.width, glc.height);
      gl.uniform1f(uni.uTime, (now - t0) / 1000);
      gl.uniform1f(uni.uIg, ig);
      gl.uniform3f(uni.uC1, C1[0], C1[1], C1[2]);
      gl.uniform3f(uni.uC2, C2[0], C2[1], C2[2]);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
    requestAnimationFrame(renderFog);
  }
  requestAnimationFrame(renderFog);

  /* ============================================================
     FRUCHT — ein fester Platz oben rechts, hinter der Überschrift.
     Einflug von der nächstgelegenen Bildkante (hier: rechts).
     ============================================================ */
  var SLOTS = [
    { x:88, y:13, w:190, blur:0, op:.96, rot:14, fg:false, dx:'-14px', dy:'16px', drift:'13s' }
  ];

  /* Startpunkt: die dem Zielplatz nächstgelegene Bildkante */
  function entryOffset(s) {
    var W = scene.clientWidth, H = scene.clientHeight;
    var px = s.x / 100 * W, py = s.y / 100 * H;
    var dL = px, dR = W - px, dT = py, dB = H - py;
    var m = Math.min(dL, dR, dT, dB);
    var over = s.w * 1.5 + 140;
    if (m === dL) return { fx:-(px + over),     fy:0, fs:.92, frot:-18 };
    if (m === dR) return { fx: (W - px + over), fy:0, fs:.92, frot: 18 };
    if (m === dT) return { fx:0, fy:-(py + over), fs:.92, frot:-14 };
    return              { fx:0, fy: (H - py + over), fs:.92, frot: 14 };
  }

  function fruitsOut() {
    Array.prototype.forEach.call(fruitB.children, function (f) { f.classList.add('pre'); });
  }

  function paintFruit(list) {
    fruitB.innerHTML = '';
    if (!list || !list.length) return;

    SLOTS.forEach(function (s, k) {
      var src = list[k % list.length];
      if (!src) return;
      var d = document.createElement('div');
      d.className = 'fruit' + (s.fg ? ' fg' : '') + (s.blur ? ' blur' : '') +
                    (reduced ? '' : ' drift') + ' pre';
      // Position und Größe als Variablen, damit CSS sie auf kleinen
      // Bildschirmen überschreiben kann.
      d.style.setProperty('--px', s.x + '%');
      d.style.setProperty('--py', s.y + '%');
      d.style.setProperty('--fw', s.w + 'px');
      d.style.setProperty('--op',   s.op);
      d.style.setProperty('--rot',  s.rot + 'deg');
      d.style.setProperty('--bl',   s.blur + 'px');
      d.style.setProperty('--dx',   s.dx);
      d.style.setProperty('--dy',   s.dy);
      d.style.setProperty('--driftdur', s.drift);
      d.style.setProperty('--dur',  FRUIT_MS + 'ms');
      d.style.setProperty('--fade', Math.round(FRUIT_MS * .45) + 'ms');
      d.style.setProperty('--delay', (k * STAGGER) + 'ms');

      var o = entryOffset(s);
      d.style.setProperty('--fx', o.fx + 'px');
      d.style.setProperty('--fy', o.fy + 'px');
      d.style.setProperty('--fs', o.fs);
      d.style.setProperty('--frot', o.frot + 'deg');

      var im = document.createElement('img');
      im.src = OBEE_ASSET('fruit-' + src + '.webp'); im.alt = '';
      d.appendChild(im);
      fruitB.appendChild(d);
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(fruitB.children, function (f) { f.classList.remove('pre'); });
      });
    });
  }

  /* ============================================================
     NAME — schiebt mit der Drehung hinaus und wieder herein
     ============================================================ */
  function wordOut() {
    if (!wordEl) return;
    var sp = wordEl.firstElementChild; if (!sp) return;
    var t = Math.round(SPIN_MS * .42);
    sp.style.transition = 'transform ' + t + 'ms cubic-bezier(.5,0,.75,0), opacity ' + t + 'ms ease-in';
    sp.style.transform  = 'translateX(' + (dir > 0 ? -70 : 70) + '%)';
    sp.style.opacity    = '0';
  }

  function wordIn(name) {
    if (!wordEl) return;
    var len = name.replace(/\s/g, '').length;
    var vw  = Math.max(7.5, Math.min(15, 150 / Math.max(6, len)));
    wordEl.style.setProperty('--word-vw', vw.toFixed(2) + 'vw');

    wordEl.innerHTML = '<span></span>';
    var sp = wordEl.firstElementChild;
    sp.textContent = name;
    sp.style.transform = 'translateX(' + (dir > 0 ? 70 : -70) + '%)';
    sp.style.opacity   = '0';

    var t = Math.round(SPIN_MS * .58);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sp.style.transition = 'transform ' + t + 'ms cubic-bezier(.16,1,.3,1), opacity ' +
                              Math.round(t * .7) + 'ms ease-out';
        sp.style.transform  = 'translateX(0)';
        sp.style.opacity    = '1';
      });
    });
  }

  /* ============================================================
     GERÄT
     ============================================================ */
  function setFrame(i, state) {
    imgs.forEach(function (im) {
      im.classList.toggle('on', im.dataset.i === String(i) && im.dataset.state === state);
    });
  }
  setFrame(1, 'off');

  function spin(mid, done) {
    if (reduced) { mid(); done && done(); return; }
    busy = true;
    var t = performance.now(), fired = false;
    (function step(now) {
      var p = Math.min(1, (now - t) / SPIN_MS);
      var e = p < .5 ? 2*p*p : 1 - Math.pow(-2*p + 2, 2) / 2;
      var f = 1 + Math.round(e * (FRAMES - 1));
      setFrame(f === FRAMES ? 1 : f, 'on');
      if (!fired && p > .42) { fired = true; mid(); }
      if (p < 1) requestAnimationFrame(step);
      else { setFrame(1, 'on'); busy = false; done && done(); }
    })(t);
  }

  /* ============================================================
     SORTE DARSTELLEN
     ============================================================ */
  function apply(i) {
    var s = S[i];
    scene.style.setProperty('--accent', s.accent);
    C1t = hex2rgb(s.accent);
    C2t = mul(C1t, .26);

    wordIn(s.name);

    if (nameEl) nameEl.textContent = s.name;
    if (typeEl) typeEl.textContent = s.type + (s.split ? ' · ' + s.split : '');
    if (aromaEl) aromaEl.textContent = s.aroma;
    if (genEl)  genEl.textContent = s.genetics;
    if (idxEl)  idxEl.textContent = (i < 9 ? '0' : '') + (i+1) + ' / ' + S.length;
    if (hudEl)  hudEl.textContent = s.name + ' loaded';
    if (terpEl) terpEl.innerHTML = s.terpenes.map(function (t) { return '<span>'+t+'</span>'; }).join('');

    if (packEl) {
      packEl.classList.remove('in');
      packEl.src = OBEE_ASSET('gen2-' + s.slug + '.webp');
      setTimeout(function () { packEl.classList.add('in'); }, 120);
    }

    Array.prototype.forEach.call(btns, function (b, k) {
      b.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });

    paintFruit(s.fruit);
  }

  function go(i, how) {
    if (!lit || busy) return;
    var next = (i + S.length) % S.length;
    if (next === cur) return;
    dir = (how === 'prev') ? -1 : 1;
    cur = next;

    if (metaEl) metaEl.classList.add('swap');
    wordOut();
    fruitsOut();

    spin(function () {
      if (metaEl) metaEl.classList.remove('swap');
      apply(cur);
    });

    /* Die Sortenleiste nur waagerecht nachführen. scrollIntoView hätte
       auch die Seite senkrecht verschoben. */
    if (rail && btns[cur]) {
      var b = btns[cur];
      rail.scrollTo({ left: b.offsetLeft - (rail.clientWidth - b.offsetWidth) / 2,
                      behavior: reduced ? 'auto' : 'smooth' });
    }
  }

  /* ============================================================
     ZÜNDUNG
     ============================================================ */
  function ignite() {
    lit = true;
    scene.classList.add('lit');
    /* Die Bühne ist ab jetzt kein Knopf mehr — sonst kündigt der
       Screenreader sie weiter als solchen an und sie fängt Tabs ab. */
    scene.removeAttribute('role');
    scene.removeAttribute('tabindex');
    scene.removeAttribute('aria-label');
    igTarget = 1;
    setFrame(1, 'on');
    dir = 1;
    apply(0);
    setTimeout(start, 3400);
  }

  function tap() {
    if (lit) return;
    taps++;
    dev.classList.remove('pulse'); void dev.offsetWidth; dev.classList.add('pulse');
    if (dots[taps-1]) dots[taps-1].classList.add('done');
    if (tapP) tapP.textContent = taps < TAPS_NEEDED ? (TAPS_NEEDED - taps) + ' more' : 'Heating';
    if (taps >= TAPS_NEEDED) {
      /* Musik noch innerhalb der Berührung starten, nicht erst im
         Timer — sonst gilt der Klick in manchen Browsern nicht mehr
         als Freigabe. Das Einblenden dauert ohnehin länger als die
         240 ms bis zur Zündung, der Beat schwillt also passend an. */
      if (window.OBEE_SOUND) window.OBEE_SOUND.autostart();
      setTimeout(ignite, 240);
    }
  }

  /* Die ganze Bühne zündet, nicht nur die Taste am Gerät.
     Am Messestand liest niemand die Anweisung — getippt wird
     irgendwo aufs Bild. Wer die Taste trifft, bekommt dasselbe.
     Ausgenommen sind die echten Bedienelemente (Pfeile, Sorten-
     leiste), sonst würde ein Sortenwechsel als Tap durchgehen. */
  scene.addEventListener('click', function (e) {
    if (lit) return;
    var t = e.target;
    if (t && t.closest &&
        t.closest('button, a, input, select, textarea, [role="tab"]')) return;
    tap();
  });

  scene.addEventListener('keydown', function (e) {
    if (lit) return;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tap(); }
  });
  scene.setAttribute('tabindex','0'); scene.setAttribute('role','button');
  scene.setAttribute('aria-label','Tap two times to activate the device');

  /* ---------- Navigation ---------- */
  Array.prototype.forEach.call(btns, function (b, i) {
    b.addEventListener('click', function () {
      stop(); go(i, i < cur ? 'prev' : 'click');
    });
  });
  /* Pfeile. preventDefault und blur, weil der Browser sonst den
     angetippten Knopf in den sichtbaren Bereich scrollt — auf dem
     Telefon sah das aus, als würde die Seite wegspringen. */
  function arrow(el, d) {
    if (!el) return;
    el.setAttribute('type', 'button');
    el.addEventListener('click', function (e) {
      e.preventDefault(); stop(); go(cur + d, d < 0 ? 'prev' : 'next');
      if (el.blur) el.blur();
    });
  }
  arrow(scene.querySelector('[data-prev]'), -1);
  arrow(scene.querySelector('[data-next]'),  1);

  /* Wischen auf der Bühne — auf dem Telefon der natürlichere Weg */
  (function () {
    var x0 = null, y0 = null;
    scene.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY;
    }, { passive: true });
    scene.addEventListener('touchend', function (e) {
      if (x0 === null || !lit) { x0 = null; return; }
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.6) {
        stop(); go(cur + (dx < 0 ? 1 : -1), dx < 0 ? 'next' : 'prev');
      }
      x0 = y0 = null;
    }, { passive: true });
  })();
  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft')  { stop(); go(cur-1, 'prev'); }
    if (e.key === 'ArrowRight') { stop(); go(cur+1, 'next'); }
  });

  function start() { if (!reduced && !auto && lit) auto = setInterval(function () { go(cur+1, 'next'); }, 6000); }
  function stop()  { if (auto) { clearInterval(auto); auto = null; } }
  scene.addEventListener('mouseenter', stop);
  scene.addEventListener('touchstart', stop, { passive:true });

  window.addEventListener('resize', function () {
    // Einflugweiten neu berechnen, damit sie zur Fenstergröße passen
    Array.prototype.forEach.call(fruitB.children, function (f, k) {
      var o = entryOffset(SLOTS[k] || SLOTS[0]);
      f.style.setProperty('--fx', o.fx + 'px');
      f.style.setProperty('--fy', o.fy + 'px');
    });
  });

  if (reduced) ignite();

  /* ---------- von aussen ansteuerbar (Übersicht) ---------- */
  window.OBEE_LOAD = function (i) {
    if (!lit) { taps = TAPS_NEEDED; ignite(); setTimeout(function () { go(i, 'next'); }, 900); }
    else { stop(); go(i, i < cur ? 'prev' : 'next'); }
    scene.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  };
})();
